import {Toaster} from "react-hot-toast";

export default function Layout({children}) {
    return (
        <main className="font-body">
            <Toaster/>
            {children}
        </main>
    )
}
